import React from "react";

export default function RecommendationsPipeline({
    title = "RECOMMENDATIONS PIPELINE",
    clickFunction
})
{
    const data =
    [
        {
            stage: "Immediate Actions",
            value: 17,
            colour: "#ef4444",
            width: 88
        },
        {
            stage: "Planned",
            value: 34,
            colour: "#f97316",
            width: 75
        },
        {
            stage: "In Progress",
            value: 11,
            colour: "#2563eb",
            width: 62
        },
        {
            stage: "Deferred",
            value: 3,
            colour: "#9ca3af",
            width: 42
        }
    ];

    const handleClick =
        (item) =>
        {
            if(clickFunction)
            {
                clickFunction(item);
            }
        };

    return (
        <div
            style={{
                width: "95%",
                height: "100%",

                display: "flex",
                flexDirection: "column",

                overflow: "hidden"
            }}
        >
            <div
                style={{
                    fontSize: "12px",
                    fontWeight: 500,

                    textTransform: "uppercase",

                    marginBottom: "16px",

                    color: "#222"
                }}
            >
                {title}
            </div>

            <div
                style={{
                    flex: 1,

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    minHeight: 0
                }}
            >
                <div
                    style={{
                        width: "100%",

                        display: "flex",
                        alignItems: "center",

                        gap: "24px"
                    }}
                >
                    <div
                        style={{
                            flex: 1,

                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",

                            minWidth: 0
                        }}
                    >
                        {
                            data.map(
                                (item, index) =>
                                {
                                    const isFirst =
                                        index === 0;

                                    const isLast =
                                        index === data.length - 1;

                                    return (
                                        <div
                                            key={item.stage}

                                            onClick={() =>
                                                handleClick(item)}

                                            style={{
                                                width:
                                                    `${item.width}%`,

                                                height:
                                                    isLast
                                                        ? "42px"
                                                        : "54px",

                                                marginTop:
                                                    isFirst
                                                        ? 0
                                                        : "-1px",

                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",

                                                background:
                                                    item.colour,

                                                color: "#ffffff",

                                                fontSize: "12px",
                                                fontWeight: 600,

                                                textAlign: "center",

                                                cursor:
                                                    clickFunction
                                                        ? "pointer"
                                                        : "default",

                                                clipPath:
                                                    isLast
                                                        ? "polygon(18% 0, 82% 0, 68% 100%, 32% 100%)"
                                                        : "polygon(4% 0, 96% 0, 88% 100%, 12% 100%)",

                                                transition:
                                                    "transform .18s ease, opacity .18s ease",

                                                boxSizing: "border-box"
                                            }}

                                            onMouseEnter={(event) =>
                                            {
                                                if(clickFunction)
                                                {
                                                    event.currentTarget.style.transform =
                                                        "scale(1.015)";

                                                    event.currentTarget.style.opacity =
                                                        "0.94";
                                                }
                                            }}

                                            onMouseLeave={(event) =>
                                            {
                                                event.currentTarget.style.transform =
                                                    "scale(1)";

                                                event.currentTarget.style.opacity =
                                                    "1";
                                            }}
                                        >
                                            {item.stage}
                                        </div>
                                    );
                                })
                        }
                    </div>

                    <div
                        style={{
                            width: "160px",

                            display: "flex",
                            flexDirection: "column",

                            gap: "0"
                        }}
                    >
                        {
                            data.map(
                                (item, index) =>
                                {
                                    const isLast =
                                        index === data.length - 1;

                                    return (
                                        <div
                                            key={item.stage}

                                            onClick={() =>
                                                handleClick(item)}

                                            style={{
                                                minHeight:
                                                    isLast
                                                        ? "42px"
                                                        : "54px",

                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",

                                                gap: "12px",

                                                borderBottom:
                                                    isLast
                                                        ? "none"
                                                        : "1px solid #e5e7eb",

                                                cursor:
                                                    clickFunction
                                                        ? "pointer"
                                                        : "default",

                                                boxSizing: "border-box"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 500,

                                                    color: "#4b5563",

                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                {item.stage}
                                            </span>

                                            <span
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 700,

                                                    color: "#111827"
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}